<template>
  <Button
    :label="label"
    :icon="icon"
    :loader="loader"
    :disabled="disabled"
    :alert="variant === 'alert'"
    :primary="variant === 'primary'"
    :success="variant === 'success'"
    :danger="variant === 'danger'"
    class="toolbar-action-button !h-[46px] !rounded-full px-2 shadow-[0_12px_32px_-24px_rgba(15,23,42,0.55)]"
  />
</template>

<script setup>
defineProps({
  label: String,
  icon: String,
  loader: Boolean,
  disabled: Boolean,
  variant: {
    type: String,
    default: 'alert',
  },
})
</script>

<style scoped>
.toolbar-action-button {
  font-size: 0.95rem;
  font-weight: 600;
}
</style>
